export const LOGIN = "@auth/LOGIN"
export const LOGOUT = "@auth/LOGOUT"
export const REGISTER = "@auth/REGISTER"
export const FETCH_USERS = "@users/FETCH_USERS"
export const FETCH_CLICKUP_USERS = "@users/FETCH_CLICKUP_USERS"
export const FETCH_SCOUT_USERS = "@users/FETCH_SCOUT_USERS"
export const FETCH_ANALYTICS_USER_LOGS = "@users/FETCH_ANALYTICS_USER_LOGS"
export const FETCH_ANALYTICS_SCOUT_LOGS = "@users/FETCH_ANALYTICS_SCOUT_LOGS"
export const FETCH_TRACKS = "@tracks/FETCH_TRACKS"
export const FETCH_BLACKLIST = "@tracks/FETCH_BLACKLIST"
export const FETCH_ARTISTS = "@artists/FETCH_ARTISTS"
export const FETCH_ARTIST_DETAIL = "@artists/FETCH_ARTIST_DETAIL"
export const FETCH_ALBUMS = "@albums/FETCH_ALBUMS"
export const UPDATE_ALBUM_TAKEDOWN_STATUS = "@albums/UPDATE_ALBUM_TAKEDOWN_STATUS"
export const FETCH_ARTIST_SOCIAL_LINKS = "@artists/FETCH_ARTIST_SOCIAL_LINKS"
export const FETCH_PLAYLISTS = "@playlists/FETCH_PLAYLISTS"
export const FETCH_PLAYLIST = "@playlists/FETCH_PLAYLIST"
export const UPDATE_PLAYLISTS_HOT_LIST = "@playlists/UPDATE_PLAYLISTS_HOT_LIST"
export const FETCH_COMPANIES = "@companies/FETCH_COMPANIES"
export const FETCH_COMPANY_BREAKDOWNS = "@companies/FETCH_COMPANY_BREAKDOWNS"
export const FETCH_CONFIRMED_OFFERS = "@offers/FETCH_CONFIRMED_OFFERS"
export const FETCH_AGREEMENT_UPLOADS = "@offers/FETCH_AGREEMENT_UPLOADS"
export const FETCH_REPORT_UPLOAD_REQUESTS = "@offers/FETCH_REPORT_UPLOAD_REQUESTS"
export const FETCH_CURRENCY_EXCHANGE_RATES = "@offers/FETCH_CURRENCY_EXCHANGE_RATES"
export const FETCH_DEAL_OFFER_STATISTICS = "@offers/FETCH_DEAL_OFFER_STATISTICS"
export const FETCH_SPOTIFY_ARTIST_REQUESTS = "@spotifyArtistRequests/FETCH_SPOTIFY_ARTIST_REQUESTS"
export const FETCH_ALLOWED_OFFER_LINKS = "@system/FETCH_ALLOWED_OFFER_LINKS"
export const SAVE_ALLOWED_OFFER_LINKS = "@system/SAVE_ALLOWED_OFFER_LINKS"
export const DELETE_ALLOWED_OFFER_LINKS = "@system/DELETE_ALLOWED_OFFER_LINKS"
export const FETCH_ALBUMS_DEFAULT_FILTERS = "@system/FETCH_ALBUMS_DEFAULT_FILTERS"
export const FETCH_MESSAGE_CONTENTS = "@system/FETCH_MESSAGE_CONTENTS"
export const SAVE_MESSAGE_CONTENT = "@system/SAVE_MESSAGE_CONTENT"
export const DELETE_MESSAGE_CONTENT = "@system/DELETE_MESSAGE_CONTENT"
export const FETCH_ACCOUNT_TYPES = "@constants/FETCH_ACCOUNT_TYPES"
export const FETCH_CONTACT_TYPES = "@constants/FETCH_CONTACT_TYPES"
export const FETCH_SERVICES = "@constants/FETCH_SERVICES"
export const FETCH_DISTRIBUTORS = "@constants/FETCH_DISTRIBUTORS"
export const FETCH_TAGS = "@constants/FETCH_TAGS"
export const FETCH_TASK_STATUSES = "@constants/FETCH_TASK_STATUSES"
export const CREATE_TAG = "@constants/CREATE_TAG"
export const FETCH_UNIT_PRICES = "@constants/FETCH_UNIT_PRICES"
export const FETCH_PIPELINE_ACTIONS = "@constants/FETCH_PIPELINE_ACTIONS"
export const CREATE_UNIT_PRICE = "@constants/CREATE_UNIT_PRICE"
export const FETCH_AFFILIATES = "@affiliates/FETCH_AFFILIATES"
export const FETCH_AFFILIATE_RELATIONSHIPS = "@affiliates/FETCH_AFFILIATE_RELATIONSHIPS"
